export const USERS_SEARCH_TYPES = [
	{ label: 'All', value: 'all' },
	{ label: 'Username', value: 'username' },
	{ label: 'Email', value: 'email' },
];

export const CAMPAIGN_SEARCH_TYPES = [
	{ label: 'ID', value: 'id' },
	{ label: 'Name', value: 'name' },
];

export const PLAYERS_SEARCH_TYPES = [
	{ label: 'Player ID', value: 'player_ids' },
	{ label: 'External Player ID (numeric)', value: 'external_player_ids' },
	{ label: 'External Player ID (string)', value: 'user_names' },
];

export const SESSIONS_SEARCH_TYPES = [
	{ label: 'Session ID', value: 'session_ids' },
	{ label: 'Partner Session ID', value: 'partner_session_ids' },
	{ label: 'Player ID', value: 'player_ids' },
	{ label: 'External Player ID (numeric)', value: 'external_player_ids' },
	{ label: 'External Player ID (string)', value: 'user_names' },
	{ label: 'AAMS Session ID', value: 'aams_session_ids' },
];

export const PLAYER_TRANSACTIONS_SEARCH_TYPES = [
	{ label: 'Transaction ID', value: 'transaction_ids' },
	{ label: 'Session ID', value: 'session_ids' },
	{ label: 'Partner Session ID', value: 'partner_session_ids' },
	{ label: 'Player ID', value: 'player_ids' },
	{ label: 'External Player ID (numeric)', value: 'external_player_ids' },
	{ label: 'External Player ID (string)', value: 'user_names' },
	{ label: 'AAMS Session ID', value: 'aams_session_ids' },
	{ label: 'TP Trx ID', value: 'thirdparty_trx_ids' },
	{ label: 'Round ID', value: 'round_ids' },
];

export const CASINO_GAMES_SEARCH_TYPES = [
	{ label: 'Game ID', value: 'game_ids' },
	{ label: 'Game Name', value: 'game_names' },
	{ label: 'AAMS Game ID', value: 'aams_game_ids' },
];
export const CASINO_GAME_PARTNERS_SEARCH_TYPES = [
	{ label: 'Skin Name', value: 'game_names' },
	{ label: 'Partner Name', value: 'partner_names' },
];

export const CASINO_GAME_PROVIDERS_SEARCH_TYPES = [{ label: 'Name', value: 'name' }];
